import { renderAppShell } from './app/shell';
import { consumeTokenFromQuery, hasToken } from './auth/session';
import { renderConnect } from './pages/connect';
import { renderPair, renderSetup } from './pages/gateways';
import { renderWifiSetup } from './pages/wifi_setup';
import { matchRoute, tabPath } from './router';
import { showToast } from './ui/dom';
import './styles/app.css';

const el = document.getElementById('app');
if (!el) throw new Error('#app missing');
const appRoot: HTMLElement = el;

function consumePairToast(url: URL): void {
  const paired = url.searchParams.get('paired');
  if (!paired) return;
  const n = url.searchParams.get('n');
  showToast(n ? `Connected (${n})` : 'Connected');
  url.searchParams.delete('paired');
  url.searchParams.delete('n');
  window.history.replaceState({}, '', url.pathname + url.search + url.hash);
}

async function navigate(): Promise<void> {
  consumeTokenFromQuery();

  const url = new URL(window.location.href);

  /* SoftAP captive / WiFiAccess QR — no session; not part of 3-tab shell */
  if (url.pathname === '/wifi-setup' || url.searchParams.get('mode') === 'wifi') {
    if (url.pathname !== '/wifi-setup') {
      window.history.replaceState({}, '', '/wifi-setup' + url.search);
    }
    await renderWifiSetup(appRoot);
    return;
  }

  const route = matchRoute(url.pathname);

  if (route.auth && !hasToken()) {
    window.history.replaceState({}, '', '/connect');
    renderConnect(appRoot);
    return;
  }

  if (url.pathname === '/connect') {
    renderConnect(appRoot);
    return;
  }
  if (url.pathname === '/setup') {
    renderSetup(appRoot);
    return;
  }
  if (url.pathname === '/pair') {
    void renderPair(appRoot, url.searchParams.get('t'));
    return;
  }

  const tab = route.tab ?? 'devices';
  const canonical = tabPath(tab);
  if (url.pathname !== canonical) {
    window.history.replaceState({}, '', canonical + url.search);
  }

  await renderAppShell(appRoot, tab);
  consumePairToast(new URL(window.location.href));
}

window.addEventListener('popstate', () => {
  void navigate();
});

void navigate();
